import { render, staticRenderFns } from "./accountResetForgottenPassword.vue?vue&type=template&id=e0345736&"
import script from "./accountResetForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./accountResetForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports